import { render, staticRenderFns } from "./ModalPreviewFastAnswers.vue?vue&type=template&id=e48b064e&scoped=true&"
import script from "./ModalPreviewFastAnswers.vue?vue&type=script&lang=js&"
export * from "./ModalPreviewFastAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48b064e",
  null
  
)

export default component.exports